// Minimal debug overlay that mirrors console output when enabled
(function () {
  const MAX_BUFFER = 500;
  const state = {
    enabled: false,
    buffer: [],
    overlayEl: null,
    origConsole: {
      log: console.log.bind(console),
      warn: console.warn.bind(console),
      error: console.error.bind(console),
      info: console.info.bind(console),
      debug: console.debug ? console.debug.bind(console) : console.log.bind(console),
    },
  };

  function formatArgs(args) {
    try {
      return args
        .map((a) => {
          if (typeof a === 'string') return a;
          if (a instanceof Error) return a.stack || a.message;
          return JSON.stringify(a);
        })
        .join(' ');
    } catch (_) {
      try {
        return args.map(String).join(' ');
      } catch (__) {
        return '[unprintable]';
      }
    }
  }

  function pushBuffer(line) {
    state.buffer.push({ t: Date.now(), line });
    if (state.buffer.length > MAX_BUFFER) state.buffer.shift();
  }

  function ensureOverlay() {
    if (state.overlayEl) return state.overlayEl;
    const el = document.createElement('div');
    el.id = '__debug_overlay';
    el.style.position = 'fixed';
    el.style.bottom = '8px';
    el.style.left = '8px';
    el.style.zIndex = '999999';
    el.style.maxWidth = '90vw';
    el.style.maxHeight = '40vh';
    el.style.overflow = 'auto';
    el.style.padding = '8px';
    el.style.borderRadius = '6px';
    el.style.background = 'rgba(0,0,0,0.75)';
    el.style.color = '#8be9fd';
    el.style.fontFamily = 'Menlo, Consolas, monospace';
    el.style.fontSize = '11px';
    el.style.lineHeight = '1.4';
    el.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';

    const header = document.createElement('div');
    header.textContent = 'Debug Overlay (tap to collapse)';
    header.style.cursor = 'pointer';
    header.style.marginBottom = '6px';
    header.style.color = '#50fa7b';

    const body = document.createElement('div');
    body.id = '__debug_overlay_body';

    header.addEventListener('click', () => {
      const collapsed = body.style.display === 'none';
      body.style.display = collapsed ? 'block' : 'none';
    });

    el.appendChild(header);
    el.appendChild(body);
    document.body.appendChild(el);
    state.overlayEl = el;
    return el;
  }

  function appendLine(line, level) {
    pushBuffer(line);
    if (!state.enabled) return;
    const el = ensureOverlay();
    const body = el.querySelector('#__debug_overlay_body');
    if (!body) return;
    const row = document.createElement('div');
    row.textContent = line;
    if (level === 'warn') row.style.color = '#f1fa8c';
    if (level === 'error') row.style.color = '#ff5555';
    body.appendChild(row);
    body.scrollTop = body.scrollHeight;
  }

  function enable() {
    if (state.enabled) return;
    state.enabled = true;
    ensureOverlay();
    // Mirror console methods
    console.log = function (...args) {
      const line = formatArgs(args);
      appendLine(line, 'log');
      state.origConsole.log(...args);
    };
    console.warn = function (...args) {
      const line = formatArgs(args);
      appendLine(line, 'warn');
      state.origConsole.warn(...args);
    };
    console.error = function (...args) {
      const line = formatArgs(args);
      appendLine(line, 'error');
      state.origConsole.error(...args);
    };
    console.info = function (...args) {
      const line = formatArgs(args);
      appendLine(line, 'info');
      state.origConsole.info(...args);
    };
    console.debug = function (...args) {
      const line = formatArgs(args);
      appendLine(line, 'debug');
      state.origConsole.debug(...args);
    };
  }

  function disable() {
    if (!state.enabled) return;
    state.enabled = false;
    // Restore console
    console.log = state.origConsole.log;
    console.warn = state.origConsole.warn;
    console.error = state.origConsole.error;
    console.info = state.origConsole.info;
    console.debug = state.origConsole.debug;
    // Remove overlay element
    if (state.overlayEl && state.overlayEl.parentNode) {
      state.overlayEl.parentNode.removeChild(state.overlayEl);
    }
    state.overlayEl = null;
  }

  // Public API
  window.__DEBUG_BUFFER = state.buffer;
  window.enableDebugOverlay = enable;
  window.disableDebugOverlay = disable;

  // Auto-enable if flag present before this loads
  if (window.__DEBUG_OVERLAY) {
    // Wait for document ready to inject overlay cleanly
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enable, { once: true });
    } else {
      enable();
    }
  }
})();
